import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="footer-background">
        <div className="footer-content">
          <div className="footer-logo">
            <img 
              src="/assets/images/logo.png" 
              alt="LGM Logo" 
              className="lgm-logo-footer"
              loading="lazy"
            />
            <div className="tagline-footer">
              Distributeur exclusif LiuGong
            </div>
          </div>
          
          <div className="copyright">
            <p>© {currentYear} LGM. Tous droits réservés.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;